export function initScrollSpy() {
  const links = document.querySelectorAll('[data-spy-link]');
  if (!links.length) return;

  const sections = Array.from(links).map(link => {
    return document.querySelector(link.getAttribute('href'));
  }).filter(Boolean);

  function update() {
    let active = sections[0];
    sections.forEach(section => {
      if (section.getBoundingClientRect().top <= 120) {
        active = section;
      }
    });
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href === `#${active?.id}`) {
        link.classList.add('sidebar-link-active');
      } else {
        link.classList.remove('sidebar-link-active');
      }
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}
